import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { AviationEvent, AviationEventType, AviationEventTypeDesc } from '../models/aviation-event.model';
import { AviationEventsService } from '../services/aviation-events.service';
import { LatLon } from '../../util/geodesy/latlon';
import * as moment from 'moment-timezone';


@Component({
  selector: 'app-nearby-events',
  templateUrl: './nearby-events.component.html',
  styleUrls: ['./nearby-events.component.scss']
})
export class NearbyEventsComponent implements OnInit, OnChanges {
  @Input() lat: number;
  @Input() lon: number;
  @Input() eventId: number = null;
  aviationEvents: AviationEvent[];
  isLoading = false;
  aviationEventTypeDesc = AviationEventTypeDesc;
  aviationEventType = AviationEventType;


  constructor(private _aviationEventsService: AviationEventsService) { }

  getDateString(aviationEvent: AviationEvent, dateType: string): string {
    let eventDate: moment;
    if (dateType === 'start') {
      eventDate = moment.tz(aviationEvent.startDateTime, 'UTC');
    } else {
      eventDate = moment.tz(aviationEvent.endDateTime, 'UTC');
    }
    const eventDateString = eventDate.clone().tz(aviationEvent.timezone).format('MM/DD/YYYY');
    return eventDateString;
  }

  filterAviationEvents(aviationEvents: AviationEvent[]): AviationEvent[] {
    aviationEvents = aviationEvents.filter((ae) => {
      if (ae.format === 'Online' || (this.eventId && ae.eventId === this.eventId)) {
        return false;
      } else {
        return true;
      }
    });
    return aviationEvents;
  }

  async ngOnInit() {
    this.isLoading = true;
    if (this.lat != null && this.lon != null) {
      this.aviationEvents = await this._aviationEventsService.getAviationEventsByLatLon(new LatLon(this.lat, this.lon), 100);
      this.aviationEvents = this.filterAviationEvents(this.aviationEvents);
    }
    this.isLoading = false;
  }

  async ngOnChanges() {
    this.isLoading = true;
    if (this.lat != null && this.lon != null) {
      this.aviationEvents = await this._aviationEventsService.getAviationEventsByLatLon(new LatLon(this.lat, this.lon), 100);
      this.aviationEvents = this.filterAviationEvents(this.aviationEvents);
    }
    this.isLoading = false;
  }

}
